export default function PageNotFound() {
    return (
        <>
            Page not found
        </>
    )
};
